import { render, staticRenderFns } from "./icon-triangle-down.vue?vue&type=template&id=ac49d196&"
import script from "./icon-triangle-down.vue?vue&type=script&lang=js&"
export * from "./icon-triangle-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports